export default __webpack_public_path__ + "static/media/icon_download.a000acc7.svg";